import { render, staticRenderFns } from "./selectBox.vue?vue&type=template&id=47499ead&scoped=true"
import script from "./selectBox.vue?vue&type=script&lang=js"
export * from "./selectBox.vue?vue&type=script&lang=js"
import style0 from "./selectBox.vue?vue&type=style&index=0&id=47499ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47499ead",
  null
  
)

export default component.exports